// Reaction emojis used across the app
export const reactionEmojis = {
  fire: '🔥',
  clap: '👏',
  dart: '🎯',
  goat: '🐐',
  vomit: '🤮',
  clown: '🤡',
  skull: '💀',
  laugh: '😂'
}